import { DuplicateProductFormValues } from "./types";
import * as yup from "yup";

export const defaultFormValues: DuplicateProductFormValues = {
  productId: "",
  newBarcode: "",
  newTitle: "",
  copyProductTemplate: false,
  copySupplier: false,
  copyPricing: true,
};

export const schema = yup.object().shape({
  productId: yup.string().required("Product is required"),
  newBarcode: yup.string().required("Barcode is required"),
  newTitle: yup.string().required("Name is required"),
  copyProductTemplate: yup.boolean(),
  copySupplier: yup.boolean(),
  copyPricing: yup.boolean(),
});
